import React, { Component } from "react";
import ReactDOM from "react-dom";

import { withReportFormats } from "../../../shared/containers/containerReportFormats";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";
import { withDownloadUnitReport } from "../../../shared/containers/containerDownloadUnitReport";
import { withReportTime } from "../../../shared/containers/containerReportTime";
import getDates from "../../../shared/services/date.service";

import { states } from "../../../reducers/queriesStates";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

import styles from "./selectedCarItem.module.scss";

class SelectedCarItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleDropDownToggleOut = this.handleDropDownToggleOut.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }

  componentDidMount() {
    const { reportFormatsDataState, onGetReportFormats } = this.props;

    if (reportFormatsDataState !== states.READY) onGetReportFormats();
  }

  componentDidUpdate() {
    if (this.state.open) {
      document.addEventListener("click", this.handleDropDownToggleOut, false);
    } else {
      document.removeEventListener("click", this.handleDropDownToggleOut, false);
    }
  }

  handleDropDownToggle() {
    this.setState({ open: !this.state.open });
  }

  handleDropDownToggleOut(event) {
    const domNode = ReactDOM.findDOMNode(this.refs.carSettings);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        open: false,
      });
    }
  }

  deleteCar() {
    const { deleteCar } = this.props;

    deleteCar();
    this.setState({ open: false });
  }

  getStyles() {
    const { isActive } = this.props;
    const { open } = this.state;

    if (open) {
      return styles.selectedCarItem_opened;
    } else if (isActive) {
      return styles.selectedCarItem_active;
    } else {
      return styles.selectedCarItem;
    }
  }

  closeDropdown() {
    this.setState({ open: false });
  }

  getReportDates() {
    const { reportStartDate, reportStartTime, reportEndDate, reportEndTime, selectedReports } = this.props;
    const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

    let startDate = new Date(reportStartDate);
    let startTime = new Date(reportStartTime);
    startDate.setHours(startTime.getHours());
    startDate.setMinutes(startTime.getMinutes());

    let endDate = new Date(reportEndDate);
    let endTime = new Date(reportEndTime);

    if (!isDayInterval) {
      endDate.setHours(endTime.getHours());
      endDate.setMinutes(endTime.getMinutes());
      endDate.setSeconds(59);
    } else {
      endDate.setHours(0);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      endTime.setHours(0);
      endTime.setMinutes(0);
      endTime.setSeconds(0);
    }

    return {
      startDate,
      endDate,
    };
  }

  downloadUnitReport() {
    const { selectedReports, selectedCars, reportFormatsData, onDownloadUnitReport, id, name, registerNumber } = this.props;
    const report = selectedReports[0];
    const reportDates = this.getReportDates();
    const reportStartDate = reportDates.startDate;
    const reportEndDate = reportDates.endDate;
    const startDate = getDates.fixISOStringDateToPost(reportStartDate);
    const endDate = getDates.fixISOStringDateToPost(reportEndDate);
    const date = new Date();
    const options = {
      units: [id],
      startDate: startDate,
      endDate: endDate,
      timeZone: date.getTimezoneOffset() / -60,
    };

    onDownloadUnitReport(report, { id, name, registerNumber }, reportFormatsData[0], options);
  }

  handleClick() {
    this.downloadUnitReport();
  }

  render() {
    const { id, title, registerNumber, color, isActive, selectedReports, handleClick } = this.props;
    const { open } = this.state;

    return (
      <div className={styles.selectedCarItemWrapper}>
        <div className={this.getStyles()} onClick={!isActive ? handleClick : null}>
          <div className={styles.carName}>
            {title}{" "}
            {selectedReports.length > 0 ? (
              <TooltipWrapper title={`Скачать "${selectedReports[0].title}" для ${title} ${registerNumber}`} position="top">
                <div
                  className={styles.downloadButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleClick();
                  }}
                >
                  <SaveAltIcon fontSize={"small"} />
                </div>
              </TooltipWrapper>
            ) : null}
          </div>

          <span className={styles.carRegNumber}>{registerNumber}</span>
        </div>
      </div>
    );
  }
}

export default withSelectedReports(withDownloadUnitReport(withReportTime(withSelectedReports(withReportFormats(SelectedCarItem)))));
